var E = "track",
  R = "2.0",
  _ = `${E}-${R}`;
export { _ as TRACK_SERVICE_KEY, E as TRACK_SERVICE_NAME, R as TRACK_SERVICE_VERSION };